// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
}

main {
  margin-block: 3em;
  font-size: 18px;
  margin-inline: auto; 
}

*,
*::after,
*::before {
  box-sizing: border-box;
}

* {
  padding: 0;
  margin: 0;
  font: inherit;
}

h2, h2 {
  text-wrap: balance;
}

h2 {
  font-size: 1.5em;
  font-weight: 900;
}

h3 {
  font-size: 1.2em;
  font-weight: 700;
}

p {
  max-width: 85ch;
  text-wrap: pretty;
  color: rgba(0 0 0 / .8);
}

main > *+* {
  margin-top: 2em;
}

section > *+* {
  margin-top: .5em;
}

strong {
  font-weight: 700;
}

ul > *+* {
  margin-top: .6em;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/footer-pages.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[":host {\n  width: 100%;\n  height: 100%;\n}\n\nmain {\n  margin-block: 3em;\n  font-size: 18px;\n  margin-inline: auto; \n}\n\n*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  font: inherit;\n}\n\nh2, h2 {\n  text-wrap: balance;\n}\n\nh2 {\n  font-size: 1.5em;\n  font-weight: 900;\n}\n\nh3 {\n  font-size: 1.2em;\n  font-weight: 700;\n}\n\np {\n  max-width: 85ch;\n  text-wrap: pretty;\n  color: rgba(0 0 0 / .8);\n}\n\nmain > *+* {\n  margin-top: 2em;\n}\n\nsection > *+* {\n  margin-top: .5em;\n}\n\nstrong {\n  font-weight: 700;\n}\n\nul > *+* {\n  margin-top: .6em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
